import { hoursToMilliseconds } from 'date-fns';

export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 25;
export const DEFAULT_SORT_BY = 'name';
export const DEFAULT_SORT_ORDER = 'desc';
export const APP_SERVICE_LIST_CACHE_TIME = hoursToMilliseconds(10);
